import { KampaayDataProvider } from 'services/api/dataProvider'
import {
  APIDrinkPreset,
  DrinkPackage,
  DrinkVariantPreset,
} from 'services/api/entities/catalog/packages/drinkPackage'
import { parseCsvFields } from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'

export const drinkpackages: EntityDescriptor<DrinkPackage> = {
  format: (_dataProvider?: KampaayDataProvider) => (record) => ({
    ID: record.id,
    ...parseCsvFields({
      'Package Name': record.name,
      Description: record.description,
    }),
    Products: parseCsvPackagesDrinks(record.products),
  }),
}

const parseCsvPackagesDrinks = (e: APIDrinkPreset[]) =>
  e.map((drink) => {
    return {
      ...parseCsvFields({
        'Drink name': drink.name,
      }),
      Variants: parseCsvPackagesVariants(drink.variants),
    }
  })

const parseCsvPackagesVariants = (e?: DrinkVariantPreset[]) =>
  e?.map((variant) => {
    return {
      ...parseCsvFields({
        'Variant name': variant?.name,
      }),
      'Drinks per person': variant?.drinksPerPerson,
    }
  }) ?? { 'Variant name': '-', 'Drinks per person': '-' }
